import { render, staticRenderFns } from "./trade.vue?vue&type=template&id=c4db7994&scoped=true&"
import script from "./trade.vue?vue&type=script&lang=js&"
export * from "./trade.vue?vue&type=script&lang=js&"
import style0 from "./trade.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./trade.vue?vue&type=style&index=1&id=c4db7994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4db7994",
  null
  
)

export default component.exports